module.exports = __webpack_public_path__ + "img/vegetable-collard-greens-350x184.62de2995.jpg";